var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 121,
    viewBox: "0 0 343 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.901489,
    width: 342,
    height: 119,
    rx: 7.5,
    fill: "#E3E6EA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.901489,
    width: 342,
    height: 119,
    rx: 7.5,
    stroke: "#73858C",
    strokeDasharray: "5 5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M171.5 46.1915C168.599 46.1915 165.763 47.0517 163.351 48.6633C160.939 50.2749 159.06 52.5655 157.949 55.2455C156.839 57.9255 156.549 60.8745 157.115 63.7195C157.681 66.5646 159.078 69.1779 161.129 71.2291C163.18 73.2803 165.793 74.6771 168.638 75.243C171.483 75.809 174.432 75.5185 177.112 74.4084C179.792 73.2983 182.083 71.4185 183.695 69.0066C185.306 66.5946 186.166 63.759 186.166 60.8582C186.162 56.9698 184.615 53.2419 181.866 50.4924C179.116 47.7428 175.388 46.1961 171.5 46.1915ZM178.166 62.1915H172.833V67.5249C172.833 67.8785 172.693 68.2176 172.442 68.4677C172.192 68.7177 171.853 68.8582 171.5 68.8582C171.146 68.8582 170.807 68.7177 170.557 68.4677C170.307 68.2176 170.166 67.8785 170.166 67.5249V62.1915H164.833C164.479 62.1915 164.14 62.0511 163.89 61.801C163.64 61.551 163.5 61.2118 163.5 60.8582C163.5 60.5046 163.64 60.1654 163.89 59.9154C164.14 59.6653 164.479 59.5249 164.833 59.5249H170.166V54.1915C170.166 53.8379 170.307 53.4988 170.557 53.2487C170.807 52.9987 171.146 52.8582 171.5 52.8582C171.853 52.8582 172.192 52.9987 172.442 53.2487C172.693 53.4988 172.833 53.8379 172.833 54.1915V59.5249H178.166C178.52 59.5249 178.859 59.6653 179.109 59.9154C179.359 60.1654 179.5 60.5046 179.5 60.8582C179.5 61.2118 179.359 61.551 179.109 61.801C178.859 62.0511 178.52 62.1915 178.166 62.1915Z",
    fill: "#C6CEDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadDesign);
export default __webpack_public_path__ + "static/media/upload-design.f9a249cb29db7fdd6594eeee4322a8d2.svg";
export { ForwardRef as ReactComponent };